import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { NoIndex } from '@/components/NoIndex';

const AuthSpinner = () => (
  <div className="min-h-screen bg-background flex items-center justify-center">
    <div className="w-8 h-8 border-2 border-primary/30 border-t-primary rounded-full animate-spin" />
  </div>
);

export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) return <AuthSpinner />;
  if (!user) return <Navigate to="/login" replace />;

  // Authed app pages are not for search engines — web has moved to mobile-first.
  return <><NoIndex />{children}</>;
}

export function RequireAdmin({ children }: { children: ReactNode }) {
  const { user, loading, isAdmin } = useAuth();

  if (loading || (user && isAdmin === null)) return <AuthSpinner />;
  if (!user) return <Navigate to="/login" replace />;
  if (isAdmin === false) return <Navigate to="/library" replace />;

  return <><NoIndex />{children}</>;
}
